var exports = {
  "zt": "diffContainer__wyc1RH",
  "zQ": "borderStylingAdded__RMqu9l",
  "vn": "borderStylingRemoved__xxpJLK",
  "T9": "borderStylingChanged__ZI7s46",
  "KY": "lineStylingUnchanged__Y9pgHG",
  "P$": "wordStylingAdded__DvPnoz",
  "rM": "wordStylingRemoved__zKWFko",
  "mc": "diffLine__mWhpcO",
};

module.exports = exports;
